export function useNuxtRoute() {
  const router = useRouter();
  const config = useRuntimeConfig();

  // Build a set of route path patterns for fast matching
  const routePatterns = computed(() =>
    router.getRoutes().map((route) => {
      // Convert Vue Router path params to regex: /gameserver/:slug -> /gameserver/[^/]+
      const pattern = route.path
        .replace(/:[^/]+\(\)/g, '[^/]*') // optional params like :slug()
        .replace(/:[^/]+/g, '[^/]+'); // required params like :slug
      return new RegExp(`^${pattern}$`);
    }),
  );

  const isNuxtRoute = (url: string) => {
    if (!url) return false;

    // External URLs are never Nuxt routes
    if (/^https?:\/\//.test(url) && !url.startsWith(config.public.websiteUrl)) {
      return false;
    }

    let path = url;
    if (path.startsWith(config.public.websiteUrl)) {
      path = path.replace(config.public.websiteUrl, '');
    }

    // Try the path as-is first (with locale prefix)
    if (routePatterns.value.some((re) => re.test(path))) {
      return true;
    }

    // Try without locale prefix: '/en/about' -> '/about'
    const stripped = path.replace(/^\/[a-z]{2}(?=\/|$)/, '');
    if (
      stripped !== path &&
      routePatterns.value.some((re) => re.test(stripped))
    ) {
      return true;
    }

    return false;
  };

  return { isNuxtRoute };
}
